import Client from "../client";

class MachineRoleRepository {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    all(): Promise<string[]> {
        return this.client.get(this.client.getRootDocument().Links["MachineRoles"]);
    }
}

export default MachineRoleRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/machineRoleRepository.ts